import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { RouterProvider } from "@tanstack/react-router";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import router from "routes";

import QueryProvider, { getContext } from "ui/Query";

import { useLog, useStart } from "features/start/fabric";
import { useDevice } from "features/auth/fabric";


const App = () => {
	const start = useStart();
	useDevice();
	useLog();

	const { queryClient } = getContext();

	return (
		<RouterProvider
			router={router}
			context={{
				user: start.user,
				profile: start.profile,
				profiles: start.profiles,
				queryClient
			}}
		/>
	);
};

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<QueryProvider>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<App />
				</LocalizationProvider>
			</QueryProvider>
		</StrictMode>
	);
}